import { render } from "./TeamLeadersTable.vue?vue&type=template&id=cdf21740&scoped=true"
import script from "./TeamLeadersTable.vue?vue&type=script&lang=js"
export * from "./TeamLeadersTable.vue?vue&type=script&lang=js"

import "./TeamLeadersTable.vue?vue&type=style&index=0&id=cdf21740&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf21740"]])

export default __exports__